<template>
<div>
  <loading :active="loading"></loading>
  <main-layout :active="5">
    <div class="col-xl-12">
      <div class="row mb-4">
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
          <div class="card text-center pt-2" style="border-left: 4px solid #F59E0B;">
            <div class="card-body">
              <p class="mb-1">Saques Pendentes</p>
              <h4 style="color: #F59E0B;">{{ pendingCount }}</h4>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
          <div class="card text-center pt-2" style="border-left: 4px solid #22C55E;">
            <div class="card-body">
              <p class="mb-1">Aprovados Hoje</p>
              <h4 style="color: #22C55E;">{{ approvedTodayCount }}</h4>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
          <div class="card text-center pt-2" style="border-left: 4px solid #EF4444;">
            <div class="card-body">
              <p class="mb-1">Rejeitados</p>
              <h4 style="color: #EF4444;">{{ rejectedCount }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-12">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0">💰 Gerenciar Saques</h4>
          <div class="d-flex gap-2">
            <select class="form-control" v-model="statusFilter" @change="getWithdrawals(1)" style="width: auto;">
              <option value="pending">Pendentes</option>
              <option value="approved">Aprovados</option>
              <option value="rejected">Rejeitados</option>
              <option value="fraud">Fraude</option>
              <option value="all">Todos</option>
            </select>
          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped mb-0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>CLIENTE</th>
                  <th>WHATSAPP</th>
                  <th>VALOR</th>
                  <th>CHAVE PIX</th>
                  <th>STATUS</th>
                  <th>DATA</th>
                  <th>AÇÕES</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="withdrawals.length <= 0">
                  <td colspan="8" class="text-center py-4">
                    <span style="color: #9CA3AF;">Nenhum saque encontrado</span>
                  </td>
                </tr>
                <tr v-for="item in withdrawals" :key="item.id">
                  <td>#{{ item.id }}</td>
                  <td>{{ item.client_name }}</td>
                  <td>{{ item.client_whatsapp }}</td>
                  <td><strong style="color: #22C55E;">R$ {{ Number(item.amount || 0).toFixed(2) }}</strong></td>
                  <td>
                    <small class="text-muted">{{ item.pix_key_type.toUpperCase() }}</small><br>
                    {{ item.pix_key }}
                  </td>
                  <td>
                    <span :class="getStatusClass(item.status)">{{ getStatusText(item.status) }}</span>
                  </td>
                  <td>{{ formatDate(item.created_at) }}</td>
                  <td>
                    <div class="btn-group" v-if="item.status === 'pending'">
                      <button class="btn btn-success btn-sm" @click="approveWithdrawal(item.id)" title="Aprovar">
                        ✓
                      </button>
                      <button class="btn btn-warning btn-sm" @click="rejectWithdrawal(item.id)" title="Rejeitar">
                        ✕
                      </button>
                      <button class="btn btn-danger btn-sm" @click="markFraud(item.id)" title="Marcar Fraude">
                        🚫
                      </button>
                    </div>
                    <span v-else class="text-muted">-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Confirmação -->
    <div v-if="showModal" class="modal-overlay" @click.self="showModal = false">
      <div class="modal-content">
        <h5>{{ modalTitle }}</h5>
        <p>{{ modalMessage }}</p>
        <textarea 
          v-model="adminNotes" 
          class="form-control mb-3" 
          placeholder="Notas (opcional)"
          rows="2"
        ></textarea>
        <div class="d-flex gap-2 justify-content-end">
          <button class="btn btn-secondary" @click="showModal = false">Cancelar</button>
          <button :class="modalButtonClass" @click="confirmAction">{{ modalButtonText }}</button>
        </div>
      </div>
    </div>
  </main-layout>
</div>
</template>

<script>
import MainLayout from "../../components/Layouts/MainLayout.vue";
import api from "../../services/funcoes-service";
import moment from "moment";
import Loading from "../../components/Layouts/Loading.vue";

export default {
  components: { MainLayout, Loading },
  data() {
    return {
      withdrawals: [],
      loading: true,
      statusFilter: "pending",
      pendingCount: 0,
      approvedTodayCount: 0,
      rejectedCount: 0,
      showModal: false,
      modalTitle: "",
      modalMessage: "",
      modalButtonText: "",
      modalButtonClass: "",
      adminNotes: "",
      pendingActionId: null,
      pendingActionType: null
    };
  },
  async mounted() {
    await this.getWithdrawals();
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },

    getStatusClass(status) {
      const classes = {
        pending: "badge bg-warning text-dark",
        approved: "badge bg-success",
        rejected: "badge bg-danger",
        fraud: "badge bg-dark"
      };
      return classes[status] || "badge bg-secondary";
    },

    getStatusText(status) {
      const texts = {
        pending: "Pendente",
        approved: "Aprovado",
        rejected: "Rejeitado",
        fraud: "Fraude"
      };
      return texts[status] || status;
    },

    async getWithdrawals(page = 1) {
      try {
        this.loading = true;
        const response = await api.get(`/wallet/withdrawals?status=${this.statusFilter}&page=${page}&limit=20`);
        if (response.data.error === 0) {
          this.withdrawals = response.data.withdrawals;
          // Update counts
          this.pendingCount = this.statusFilter === "pending" ? this.withdrawals.length : this.pendingCount;
        }
      } catch (error) {
        this.$toast.error("Erro ao carregar saques");
      } finally {
        this.loading = false;
      }
    },

    approveWithdrawal(id) {
      this.pendingActionId = id;
      this.pendingActionType = "approve";
      this.modalTitle = "✅ Aprovar Saque";
      this.modalMessage = "Você confirma a aprovação deste saque? O pagamento deverá ser realizado manualmente via PIX.";
      this.modalButtonText = "Confirmar Aprovação";
      this.modalButtonClass = "btn btn-success";
      this.adminNotes = "";
      this.showModal = true;
    },

    rejectWithdrawal(id) {
      this.pendingActionId = id;
      this.pendingActionType = "reject";
      this.modalTitle = "❌ Rejeitar Saque";
      this.modalMessage = "Você confirma a rejeição? O saldo será devolvido para a carteira do cliente.";
      this.modalButtonText = "Confirmar Rejeição";
      this.modalButtonClass = "btn btn-warning";
      this.adminNotes = "";
      this.showModal = true;
    },

    markFraud(id) {
      this.pendingActionId = id;
      this.pendingActionType = "fraud";
      this.modalTitle = "🚫 Marcar como Fraude";
      this.modalMessage = "ATENÇÃO: Isso bloqueará permanentemente a carteira do cliente. Tem certeza?";
      this.modalButtonText = "Confirmar Fraude";
      this.modalButtonClass = "btn btn-danger";
      this.adminNotes = "";
      this.showModal = true;
    },

    async confirmAction() {
      try {
        this.loading = true;
        const endpoint = `/wallet/withdrawals/${this.pendingActionId}/${this.pendingActionType}`;
        const response = await api.post(endpoint, { notes: this.adminNotes });
        
        if (response.data.error === 0) {
          this.$toast.success(response.data.message);
          this.showModal = false;
          await this.getWithdrawals();
        } else {
          this.$toast.error(response.data.message);
        }
      } catch (error) {
        this.$toast.error("Erro ao processar ação");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 24px;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
}

.badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
}

.btn-group .btn {
  padding: 4px 10px;
  font-size: 14px;
}

.gap-2 {
  gap: 8px;
}
</style>
